import { useSearch } from 'storefront-modules/search/hooks'
import { useGoogleAnalytics } from 'storefront-modules/third-party'
import useAppConfig from '#/src/custom/hooks/useAppConfig'

export const useCustomSearch = () => {
  const config = useAppConfig()
  const GA = useGoogleAnalytics()

  const onSubmit = (value: string) => {
    GA.search(value)
  }

  return useSearch({
    config: {
      paths: {
        searchApi: '/api/search',
        searchPage: '/search'
      },
      onSubmit
    },
    searchQueryMinLength: config.searchQueryMinLength
  })
}
